<template>
  <div>
    <transition name="fade">
      <div class="submit-btn">
        <button class="sb-btn" type="button" @click="doRegist" :disabled="isSubmit">{{ btnText }}</button>
      </div>
    </transition>
    <div class="sending" v-if="isSubmit">
      <div class="sending__img">
        <img src="static/img/sending.png" alt="">
      </div>
      <div class="sending__text">
        <p class="sending__text__header">登録中...</p>
        <p class="sending__text__text">この後の画面で求人紹介のための日程調整ができます</p>
      </div>
    </div>
  </div>
</template>

<script>
import constMixin from '../../mixins/ConstMixin'
import AccountEngagementMixin from '../../mixins/AccountEngagementMixin'
import Careers from '../../mixins/CareerMixin'
import nowStatuses from '../../mixins/NowStatusMixin'
import prefsMixin from '../../mixins/PrefsMixin'
import GenderMixin from '../../mixins/GenderMixin'
import HopeWorkTimingMixin from '../../mixins/HopeWorkTimingMixin'
import FullTimeWorkerPeriods from '../../mixins/FullTimeWorkerPeriodMixin'
import functionsMixin from '../../mixins/functionsMixin'
import Spinner from 'vue-simple-spinner'

export default {
  name: 'FormSubmitButton',
  mixins: [constMixin, AccountEngagementMixin, Careers, nowStatuses, prefsMixin, GenderMixin, HopeWorkTimingMixin, FullTimeWorkerPeriods, functionsMixin],
  components: {
    Spinner
  },
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isSubmit: false,
      show: {
        kairos: false
      },
      btnText: '登録する',
      customer: {}
    }
  },
  watch: {
    isSubmit: function () {
      if (this.isSubmit) {
        this.btnText = '登録中'
      } else {
        this.btnText = '登録する'
      }
    }
  },
  methods: {
    doRegist: function () {
      this.isSubmit = true
      this.axios.post(this.constApi.url.request, this.formData)
        .then((response) => {
          if (response.hasOwnProperty('data')) {
            if (response.data.hasOwnProperty('response')) {
              this.customer = response.data.response
              this.show.kairos = true
              // AEフォームハンドラーへ送信（Kairos送信とは独立して動き、失敗しても後続は止めない）
              this.sendAeForm(this.formData, this.customer)
              this.$emit('form-submit', this.customer)
            }
          }
        })
        .catch((e) => {
          let resData = {
            type: 'other',
            data: {
              message: this.constApi.badRequestMessage
            }
          }
          if (e.hasOwnProperty('response')) {
            if (e.response.hasOwnProperty('data')) {
              resData.type = 'validate'
              resData.data = e.response.data
            }
          }
          this.$emit('form-error', resData)
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/import/var";
.sb-btn {
  &[disabled] {
    background: #bfbfbf;
    border-bottom: solid 6px #9a9a9a;
  }
}
.sending {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2;
  & &__img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20%;
    @include mq(md) {
      width: 30%;
    }
    img {
      animation: rotate-anime 3s linear infinite;
      margin: 0 auto;
    }
  }
  & &__text {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    padding-bottom: 7em;
    @include mq(md) {
      padding: 0 1.2em 11em;
    }
    @include mq-max("390px") {
      padding: 0 1.5em 3em;
    }
    &__header {
      text-align: center;
      font-size: 2.5em;
      font-weight: bold;
      color: $orange;
    }
    &__text {
      text-align: center;
      font-size: 1.8rem;
    }
  }
}
@keyframes rotate-anime {
  0%  {transform: rotate(0);}
  100%  {transform: rotate(-360deg);}
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormSubmitButton.vue